import actions from './actions';
import { createReducer } from '../../../../../helpers/reducer';

const initState = {
  isLoading: false,
  agencies: undefined,
};

function onLoadAgenciesRequest(state) {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadAgenciesSuccess(state, { payload }) {
  const { agencies } = payload;

  return {
    ...state,
    isLoading: false,
    agencies,
  };
}

function onLoadAgenciesError(state) {
  return {
    ...state,
    isLoading: false,
  };
}

export default createReducer(initState, {
  [actions.LOAD_AGENCIES_REQUEST]: onLoadAgenciesRequest,
  [actions.LOAD_AGENCIES_SUCCESS]: onLoadAgenciesSuccess,
  [actions.LOAD_AGENCIES_ERROR]: onLoadAgenciesError,
});
